var _rect, _text, _text2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProbeFig3WhatEachLensCaught(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "What each lens caught in the worked example")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "One reasonable-looking memo (adopt a paid feature-flag SaaS), six independent readings, from the repo's own example run")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 104,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 136,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "clarify the thinking"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 160,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "The requirement drifts from \"toggle at runtime\" to \"full targeting platform\" without acknowledgment"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 190,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 222,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "challenge assumptions"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 246,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "The conclusion needs four unshown things to all be true; each is plausible, none is demonstrated"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 276,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 308,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "evidence basis"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 332,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "No citations, measurements, or dated inputs; the load-bearing cost sentence compares one unstated number to another"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 362,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 394,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "alternative viewpoints"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 418,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "At least five credible options were never named; no perspective outside the proposing team appears"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 448,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 480,
    fontSize: 13,
    fontWeight: 600,
    fill: "#16A34A"
  }, "implications and consequences"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 504,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "Reversibility decays with success: a one-day rollback at month 1 becomes a quarter of work by month 18"), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 534,
    width: 1104,
    height: 76,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#7C3AED",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 566,
    fontSize: 13,
    fontWeight: 600,
    fill: "#7C3AED"
  }, "question the question"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 590,
    fontSize: 12.5,
    fill: "#1A2F2A"
  }, "The title names the answer before the Context states the problem"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProbeFig3WhatEachLensCaught);
export default __webpack_public_path__ + "static/media/probe-fig3-what-each-lens-caught.18deb6166544d6a23904b59a307dfb9c.svg";
export { ForwardRef as ReactComponent };